import { api } from '@/api';

export interface FireflyConnectResponse {
  connectionId: string;
  accounts: {
    accountId: string;
    accountData?: {
      $id: string;
      account_name: string;
      account_type: string;
      currency: string;
      current_balance: number;
    };
    error?: string;
  }[];
}

export interface FireflyFullImportResult {
  categories: { imported: number; reused: number };
  rules: { imported: number; skipped: number };
  transactions: { fetched: number; saved: number };
}

export interface FireflySyncResponse {
  accounts: {
    accountId: string;
    accountData?: {
      $id: string;
      account_name: string;
      current_balance: number;
    };
    error?: string;
  }[];
}

class FireflyConnectionService {
  /**
   * Connect a Firefly III instance with URL + Personal Access Token.
   */
  async connectFirefly(
    baseUrl: string,
    token: string
  ): Promise<FireflyConnectResponse> {
    const result = await api.v1['bank-connections'].firefly.connect.post({
      baseUrl,
      token,
    });
    if (result.error) throw result.error;
    return result.data as FireflyConnectResponse;
  }

  /**
   * Run full atomic import: categories → rules → transactions.
   */
  async fullImport(connectionId: string): Promise<FireflyFullImportResult> {
    const result = await api.v1['bank-connections'].firefly['full-import']({
      connectionId,
    }).post({});
    if (result.error) throw result.error;
    return result.data as FireflyFullImportResult;
  }

  /**
   * Sync accounts and transactions for a Firefly III connection.
   */
  async syncFireflyConnection(
    connectionId: string
  ): Promise<FireflySyncResponse> {
    const result = await api.v1['bank-connections'].firefly
      .sync({ connectionId })
      .post({});
    if (result.error) throw result.error;
    return result.data as FireflySyncResponse;
  }
}

export const fireflyConnectionService = new FireflyConnectionService();
